





























import { websiteText } from '@/mixins/websiteTexts';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class EverydayBar extends Vue {
    @Prop() readonly name!: string;
    @Prop() readonly organization!: string;
    @Prop() readonly avatar!: string;
    showEverydayFields: boolean = false;
    constructor() {
        super();
        //if this.getCookieValue('showEverydayFields') is empty or doesn't exist, set showEverydayFields to true
        if (this.getCookieValue('showEverydayFields') === '') {
            this.showEverydayFields = true;
        } else {
            this.showEverydayFields = this.getCookieValue('showEverydayFields') === 'true';
        }
    }

    @Watch('showEverydayFields')
    onShowEverydayFieldsChanged() {
        document.cookie = `showEverydayFields=${this.showEverydayFields}; path=/`;
        location.reload();
    }

    getCookieValue(name: string): string {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2)
            return parts
                .pop()!
                .split(';')
                .shift()!;
        return '';
    }
}
